interface SchemaOrgProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

const baseSchemas: Record<string, Record<string, unknown>> = {
  Organization: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '乐鱼官网',
    url: 'https://www.leyu.com',
    description: '乐鱼官网是您值得信赖的官方平台，提供安全、稳定、流畅的用户体验。',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-0000',
      contactType: 'customer service',
      availableLanguage: 'Chinese',
      areaServed: 'CN',
    },
  },
  WebSite: {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '乐鱼官网',
    url: 'https://www.leyu.com',
    description: '乐鱼官网 - 官方正版入口，安全可信赖',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.leyu.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
};

export default function SchemaOrg({ type, data }: SchemaOrgProps) {
  const schema = baseSchemas[type]
    ? { ...baseSchemas[type], ...(data || {}) }
    : { '@context': 'https://schema.org', '@type': type, ...(data || {}) };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}